import { useEffect, useState } from 'react';
import {
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn
  } from "react-icons/fa";
  import { FaXTwitter, FaTiktok, FaYoutube } from "react-icons/fa6";
  import { BsLink45Deg } from "react-icons/bs";
  import { useTranslation } from 'react-i18next';
  import { useLanguage } from '../hooks/useLanguage';
  import BASE_URL from '../api/config';

  const Footer = () => {
    const { t } = useTranslation('common');
    const { isAr } = useLanguage();
    const [contactInfo, setContactInfo] = useState(null);

    useEffect(() => {
      fetch(`${BASE_URL}/contact-info`)
        .then(r => r.json())
        .then(json => {
          if (json.data) setContactInfo(json.data);
        })
        .catch(() => {});
    }, []);

    const langData = contactInfo ? (isAr ? contactInfo.ar : contactInfo.en) : null;
    const email    = langData?.email;
    const phone    = langData?.phone;
    const address  = langData?.address;
    const socials  = langData?.social_links || {};

    return (
      <footer className="bg-black text-white px-8 md:px-16 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-10">
  
        <div>
  {/* Logo */}
  <img
    src="/Abdullah  el-Nasr.png"
    alt="Logo"
    className="w-28 mb-4"
  />
<h3 className="text-lg font-lexend mb-2">
  {t('footer.contactInfo')}
</h3>

<div className="w-21 h-px bg-gradient-to-r from-white/70 via-white/30 to-transparent "></div>


  
<div className="text-sm text-gray-300 space-y-8 mt-4">

{/* Group 1 */}
<div className="space-y-4">
  {phone && (
    <div className="flex items-center gap-3">
      <FaPhoneAlt className="text-gray-400" />
      <a href={`tel:${phone}`} className="hover:text-white transition-colors cursor-pointer">
        {phone}
      </a>
    </div>
  )}

  {socials.telegram && (
    <div className="flex items-center gap-3">
      <BsLink45Deg className="text-gray-400" />
      <a href={socials.telegram} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
        {socials.telegram}
      </a>
    </div>
  )}
</div>

{/* Group 2 */}
<div className="space-y-4">
  {address && (
    <div className="flex items-center gap-3">
      <FaMapMarkerAlt className="text-gray-400" />
      <span>{address}</span>
    </div>
  )}

  {email && (
    <div className="flex items-center gap-3">
      <FaEnvelope className="text-gray-400" />
      <a href={`mailto:${email}`} className="hover:text-white transition-colors">
        {email}
      </a>
    </div>
  )}
</div>

</div>

          </div>
  
          {/* Social icons */}
          <div className="flex gap-4 mt-60">
            {socials.facebook && (
              <a href={socials.facebook} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaFacebookF />
              </a>
            )}
            {socials.instagram && (
              <a href={socials.instagram} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaInstagram />
              </a>
            )}
            {socials.twitter && (
              <a href={socials.twitter} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaXTwitter />
              </a>
            )}
            {socials.linkedin && (
              <a href={socials.linkedin} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaLinkedinIn />
              </a>
            )}
            {socials.youtube && (
              <a href={socials.youtube} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaYoutube />
              </a>
            )}
            {socials.tiktok && (
              <a href={socials.tiktok} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-gray-600 flex items-center justify-center shrink-0 hover:bg-white hover:text-black transition">
                <FaTiktok />
              </a>
            )}
          </div>
        </div>
  
        {/* Line */}
        <div className="mt-10 border-t border-gray-700"></div>
      </footer>
    );
  };
  
  export default Footer;